import { defaultLocale, locales } from "@/i18n/config";

export function normalizeMonarchLocale(locale: string | undefined): string {
  if (!locale) {
    return defaultLocale;
  }

  const base = locale.split(/[-_]/)[0]?.toLowerCase();
  if ((locales as readonly string[]).includes(base)) {
    return base;
  }

  return defaultLocale;
}

export function isEnglishMonarchLocale(locale: string): boolean {
  return normalizeMonarchLocale(locale) === defaultLocale;
}
